import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';
import RarityLink from '../RarityLink';
import ItemIcon from '../ItemIcon';
import ItemDetailsList from './ItemDetailsList';

export default class SimpleItemCard extends Component {

    render() {
        const {name, image, itemKey, category, rarity, size, tags} = this.props;

        const itemDetailList = tags ?
            <Card.Content extra>
                <ItemDetailsList tags={tags} />
            </Card.Content> :
            null;

        return (
            <Card key={itemKey}>
                <Card.Content>
                    <ItemIcon image={image} floated='left' rarity={rarity} size={size} />
                    <Card.Header>
                        <RarityLink rarity={rarity} to={`/items/${itemKey}`}>
                            {name.English}
                        </RarityLink>
                    </Card.Header>
                    <Card.Meta>
                        {category}
                    </Card.Meta>
                </Card.Content>
                {itemDetailList}
            </Card>
        )
    }
}

SimpleItemCard.propTypes = {
    name: PropTypes.object.isRequired,
    image: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    itemKey: PropTypes.string.isRequired,
    rarity: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['mini','small', 'medium', 'large', 'big', 'huge', 'massive']),
    tags: PropTypes.arrayOf(PropTypes.string),
};


// WEBPACK FOOTER //
// ./src/common/items/SimpleItemCard.jsx